import type { SVGProps } from 'react';

const SvgCdp = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" {...props}>
    <path
      fill={props.color}
      d="M24.5 29.22H9.44C4.5 29.22.49 25.2.49 20.27c0-3.97 2.6-7.35 6.19-8.52.74-5.14 5.12-8.97 10.37-8.97 5.78 0 10.48 4.7 10.48 10.48 0 .8-.08 1.57-.24 2.3 1.78.84 4.24 2.91 4.24 6.54 0 3.99-3.08 7.12-7.01 7.12ZM9.44 13.02c-3.99 0-7.24 3.25-7.24 7.24s3.25 7.24 7.24 7.24H24.5c2.97 0 5.3-2.38 5.3-5.41 0-3.98-3.76-5.19-3.8-5.2a.854.854 0 0 1-.56-1.07c.24-.79.36-1.65.36-2.57 0-4.83-3.93-8.77-8.77-8.77-4.17 0-7.69 2.89-8.56 6.87a8.953 8.953 0 0 1 7.89 3.23l-1.32 1.08a7.208 7.208 0 0 0-5.6-2.65Z"
    />
  </svg>
);

export default SvgCdp;
